import { Fragment, useContext, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import SelectableContext from '../../../contexts/local/selectable/SelectableContext';
import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import StatusBarButton from '../../layout/StatusBarButton';
import Loading from '../../ui-elements/Loading';
import Channel from '../discarding/panel/Channel';
import Panel from '../discarding/panel/Panel';
import PlantBlockSelectable from '../discarding/panel/PlantBlockSelectable';

const PanelSlotSelector = ({ forwardTo, selectedSlots }) => {
  const navigate = useNavigate();
  const { loading } = useContext(UIContext);
  const { selection, Sidebar, isSelecting, handleSelection } = useContext(SelectableContext);
  const { additionalProcessInformation, activeProcessId, continueProcess } = useContext(ProcessContext);
  const [showContinueButton, setShowContinueButton] = useState(false);
  const totalPlantSlotsPerChannel = parseInt(
    import.meta.env.VITE_PANELSETTINGS_TOTALPLANTSLOTSPERCHANNEL, 10
  );

  const [occupancyArray, setOccupancyArray] = useState([]);

  useEffect(() => {
    if (additionalProcessInformation) {
      setOccupancyArray(additionalProcessInformation.virtualOccupancy ?? []);
    }
  }, [additionalProcessInformation]);

  useEffect(() => {
    if (selection.length > 0 && !isSelecting) {
      setShowContinueButton(true);
    } else if (isSelecting) {
      setShowContinueButton(false);
    }
  }, [selection, isSelecting]);

  useEffect(() => {
    if (selectedSlots) {
      const executableSlots = selectedSlots?.filter(item => item?.executable === true).map(sl => sl?.destinationSlot);
      console.log("executableSlots: ", executableSlots);
      handleSelection(executableSlots);
      const automatedProcess = async () => {
        await proceedToConfirmation(executableSlots);
      };
      automatedProcess();
    }
 }, [selectedSlots]);

  const proceedToConfirmation = useCallback(async (executableSlots = null) => {
    try {
      if (executableSlots) {
        await continueProcess(activeProcessId, executableSlots);
      }else{
        await continueProcess(activeProcessId, selection);
      }
      if (forwardTo) {
        navigate(forwardTo);
      }
    } catch (error) {
      console.error(error);
    }
  }, [activeProcessId, continueProcess, forwardTo, navigate, selection]);

  const renderBlock = (block, index, channelIndex) => {
    const slotSpan = block.endPlantSlotOrdinalNumber - block.startPlantSlotOrdinalNumber + 1;
    const blockWidthPercent = `${(slotSpan / totalPlantSlotsPerChannel) * 100}%`;

    return (
      <PlantBlockSelectable
        key={`${index}-${block.startPlantSlotOrdinalNumber}-${block.endPlantSlotOrdinalNumber}`}
        block={block}
        channelNr={channelIndex - 1}
        index={index}
        disabled={!block.isOccupiable}
        hideContent={!block.isOccupiable && !block.isOccupied}
        style={{ width: blockWidthPercent }}
        harvesting={false}
      />
    );
  };

  return loading ? (
    <Loading fullScreen />
  ) : (
    <Fragment>
      {Sidebar}
      <Panel alignment='horizontal'>
        {occupancyArray.map((channel, channelIndex) => (
          <Channel key={channelIndex} channel={channel}>
            {channel.map((block, index) => renderBlock(block, index, channelIndex + 1))}
          </Channel>
        ))}
      </Panel>
      {showContinueButton && (
        <Fragment>
          <StatusBarButton
            label='Continue'
            icon='fas fa-chevron-right'
            reversed={true}
            clickHandler={() => proceedToConfirmation()}
            statusSlot={5}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default PanelSlotSelector;
